export default theme => ({

    loadingPage: {
        position:"absolute",
        top:0,
        left:0,
        width: "100%",
        height: "100%",
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        backgroundColor: "#fff", 
        zIndex: 100
    }
})

